"use strict";
const hostname = window.location.hostname;
const portNumber = window.location.port;
module.exports = {
//  NODE_ENV: "http://desktop-dnq7e5s:8888/service",
  //NODE_ENV: "http://" + hostname + ":8888/service",
   NODE_ENV: "https://" + hostname + ":" + portNumber + "/service",
  //NODE_ENV: 'http://' + hostname + ':8888/service',
};



// WEBPACK FOOTER //
// ./src/components/service/prod.env.js